import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect, useState } from "react";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { FormTimeMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_time_masked_input";
import { ModalLoading } from "../../../../../../common/components/modal_loading";


import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import dayjs from "dayjs";


import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DropDownFuncionario } from "../../../../../../common/components/dropdown_funcionario";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DiarioObrasEfetivoForm, DiarioObrasEfetivoSchema } from "../../../schemas/DiarioObrasEfetivo/diario_obras_efetivo";
import { DropDownCargo } from "../../../../../../common/components/dropdown_cargo";
import { DropDownFornecedor } from "../../../../../../common/components/dropdown_fornecedor";
import { DiarioObrasEquipamentoForm, DiarioObrasEquipamentoSchema } from "../../../schemas/DiarioObrasEquipamento/diario_obras_equipamento";
import { DropDownEquipamentos } from "../../../../../../common/components/dropdown_equipamentos";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";


type Props = {
  open: boolean,
  saving: boolean,
  selectedEquipamento: DiarioObrasEquipamentoForm | null,
  IdDiarioObras: number;
  onSubmit: (form: DiarioObrasEquipamentoForm) => void,
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,
  onClose: () => void,
};

export const EquipamentoModal = ({
  open,
  saving,
  IdDiarioObras,
  selectedEquipamento,
  onOpenChangeHistory,
  onSubmit,
  onClose,
}: Props) => {
  const hookForm = useForm<DiarioObrasEquipamentoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(DiarioObrasEquipamentoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedEquipamento) {
        hookForm.reset({
          IdDiarioObrasEquipamento: selectedEquipamento.IdDiarioObrasEquipamento,
          IdDiarioObras: selectedEquipamento.IdDiarioObras,
          Descricao: selectedEquipamento.Descricao,
          Quantidade: selectedEquipamento.Quantidade,
          Tipo: selectedEquipamento.Tipo,
          IdMaquinaEquip: selectedEquipamento.IdMaquinaEquip,
        });
      }
      } else {
        hookForm.reset({
          IdDiarioObrasEquipamento: undefined,
          IdDiarioObras: IdDiarioObras,
          Descricao: "",
          Quantidade: null,
          Tipo: "0",
          IdMaquinaEquip: null,
        });
      }
  }, [hookForm, open, IdDiarioObras, selectedEquipamento]);

  const handleChangeHistory = useCallback(() => {
    if (selectedEquipamento) {
      onOpenChangeHistory(selectedEquipamento.IdDiarioObrasEquipamento, LogTipoTabela.DIARIO_OBRAS_EQUIPAMENTOS);
    }
  }, [selectedEquipamento, onOpenChangeHistory]);
  const handleSubmit = useCallback((form: DiarioObrasEquipamentoForm) => {
    if (!saving){
      onSubmit(form);
      // hookForm.reset(); 
    } 
  }, [onSubmit, saving]);

  const handleClose = useCallback(() => {
    if (!saving){
      onClose();
      hookForm.reset(); 
    } 
  }, [hookForm, onClose, saving]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
       sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "42rem",
          },
        },
      }}
      >
      <DialogTitle>
        Equipamento
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={selectedEquipamento ? "Editar" : "Cadastrar"} arrangement="fullRow">
            <>
              <DropDownEquipamentos
                name='IdMaquinaEquip'
                required={true}
                reactHookForm={hookForm}
              />
              <div className="md:col-span-2">
                <DefaultFormInput
                  name='Descricao'
                  label="Descrição"
                  multiline={true}
                  rows={2}
                  reactHookForm={hookForm}
                />
              </div>

              <FormRadioGroupInput
                name="Tipo"
                label="Tipo de Equipamento"
                readOnly={saving}
                options={[
                  { id: 0, label: "Próprio" },
                  { id: 1, label: "Alugado" },
                ]}
                reactHookForm={hookForm}
              />

              <DefaultFormInput
                name='Quantidade'
                label="Quantidade"
                reactHookForm={hookForm}
              />
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div className="w-[220px]">
            {
              isNotNullOrUndefined(selectedEquipamento) &&
              <PrimaryButton
              buttonColor="yellow"
              onClick={handleChangeHistory}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>
          <div className="flex flex-row gap-2 w-full justify-end">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}